import React from 'react';

import {ImpulseSpinner} from 'react-spinners-kit';
import {Button} from 'react-bootstrap';

import './LoadingButton.scss';

function LoadingButton(props) {
    const {loading, ...rest} = props;

    return (
        <>
            <Button
                {...rest}
                className={`btn-loading ${rest.className} ${
                    loading ? 'loading' : ''
                }`}
            >
                <div className='loading-indicator'>
                    <ImpulseSpinner
                        size={30}
                        frontColor='white'
                        backColor='rgba(255,255,255,0.4)'
                        loading={true}
                    />
                </div>
                <span>{rest.children}</span>
            </Button>
        </>
    );
}
export default LoadingButton;
